module.exports = require("@splunk/dashboard-visualizations/Line");